import React from 'react';
import { Plane, Globe, Headphones, Users, Clock, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const iconMap = {
  Plane,
  Globe,
  Headphones,
  Users,
  Clock,
  MessageCircle,
};

const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      id: 1,
      title: t('service1Title'),
      description: t('service1Desc'),
      icon: 'Plane'
    },
    {
      id: 2,
      title: t('service2Title'),
      description: t('service2Desc'),
      icon: 'Globe'
    },
    {
      id: 3,
      title: t('service3Title'),
      description: t('service3Desc'),
      icon: 'Headphones'
    },
    {
      id: 4,
      title: t('service4Title'),
      description: t('service4Desc'),
      icon: 'Users'
    },
    {
      id: 5,
      title: t('service5Title'),
      description: t('service5Desc'),
      icon: 'Clock'
    },
    {
      id: 6,
      title: t('service6Title'),
      description: t('service6Desc'),
      icon: 'MessageCircle'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('ourServices')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('servicesSubtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border border-gray-100"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                  <IconComponent className="text-blue-600 group-hover:text-white transition-colors duration-300" size={32} />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
